const atomicSubmissionGroups = [
  ['eggs', '03', ['005']],
  ['canned-fish', '08', ['001', '002', '003']],
  ['cheese', '02', ['001']],
  ['plant-yogurt', '00', ['001']],
  ['plant-cheese', '00', ['002']],
  ['nut-seed-butters', '00', ['003']],
  ['tofu', '02', ['004']],
  ['bs-breakfast-cereal', '05', ['001BC']],
  ['bs-instant-oatmeal', '05', ['001IO']],
  ['bs-infant-cereal', '09', ['001BS']],
  ['canned-fruits-vegetables', '19', ['001CF', '001CV']],
  ['frozen-fruits-vegetables', '19', ['001FF', '001FV']],
  ['dried-fruits', '19', ['004']],
  ['infant-meats', '13', ['001', '101']],
  ['bs-infant-meats', '13', ['001BS', '101BS']],
  ['rfi-infant-meats', '13', ['001RFI', '101RFI']],
  [
    'infant-fruits-vegetables',
    '12',
    ['001', '002', '003', '101', '102', '103'],
  ],
  [
    'bs-infant-fruits-vegetables',
    '12',
    ['001BS', '002BS', '003BS', '101BS', '102BS', '103BS'],
  ],
  [
    'rfi-infant-fruits-vegetables',
    '12',
    ['001RFI', '002RFI', '003RFI', '101RFI', '102RFI', '103RFI'],
  ],
  ['juice', '54', ['001', '002', '101']],
  ['peanut-butter', '06', ['001']],
  ['dry-beans', '06', ['002']],
  ['canned-beans', '06', ['003']],
  ['whole-milk', '51', ['001', '003', '011']],
  ['reduced-fat-milk', '52', ['002', '004', '006', '012', '014', '019']],
  ['yogurt', '50', ['001', '002']],
  ['plant-milk', '52', ['011']],
  ['plant-milk', '55', ['001', '002', '003', '004', '005', '006', '007', '008']],
  ['bread', '16', ['001']],
  ['brown-rice', '16', ['003']],
  ['bulgur', '16', ['004']],
  ['oats', '16', ['005']],
  ['bs-oats', '16', ['005BS']],
  ['barley', '16', ['006']],
  ['corn-tortilla', '16', ['007', '007BS']],
  ['wheat-tortilla', '16', ['008', '008BS']],
  ['wheat-pasta', '16', ['009', '009BS']],
  ['whole-wheat-bagels', '16', ['010']],
  ['bs-whole-wheat-bagels', '16', ['010BS']],
  ['whole-wheat-muffins', '16', ['011']],
  ['bs-whole-wheat-muffins', '16', ['011BS']],
  ['whole-wheat-pita', '16', ['012']],
  ['bs-whole-wheat-pita', '16', ['012BS']],
  ['bs-whole-wheat-naan', '16', ['013']],
  ['bs-quinoa', '16', ['014']],
  ['bs-wild-rice', '16', ['015']],
  ['corn-masa-flour', '16', ['016']],
  ['bs-corn-masa-flour', '16', ['016BS']],
  ['whole-grain-cornmeal', '16', ['017']],
  ['bs-cornmeal', '16', ['017BS']],
]

const atomicSubmissionRegistry = atomicSubmissionGroups.reduce(
  (registry, [submissionKey, category, subCategories]) => {
    subCategories.forEach(subCategory => {
      registry[`${category}/${subCategory}`] = { submissionKey }
    })
    return registry
  },
  {}
)

if (Object.keys(atomicSubmissionRegistry).length !== 92) {
  throw new Error('The atomic submission registry must contain 92 product types.')
}

export const getAtomicSubmissionConfig = product => {
  const category = product?.category || product?.fkCategory
  const subCategory = product?.subCategory || product?.fkSubCategory
  return atomicSubmissionRegistry[`${category}/${subCategory}`] || null
}

export const isAtomicSubmission = product =>
  getAtomicSubmissionConfig(product) !== null

const formatRetailPrice = value => {
  if (value === null || value === undefined || value === '') return null
  const number = Number(value)
  return Number.isFinite(number) ? number.toFixed(2) : value
}

export const buildAtomicSubmission = (product, user, getProductSpecific) => {
  const ProductSpecific = { ...getProductSpecific(product) }
  delete ProductSpecific.UPC
  delete ProductSpecific.pkUPC

  return {
    fkCategory: product.category || product.fkCategory,
    fkSubCategory: product.subCategory || product.fkSubCategory,
    UPC: product.UPC,
    Comments: product.Comments || product.comments || null,
    ActiveDate:
      product.ActiveDate || product.activeDate || '1753-01-01T12:00:00',
    DeActiveDate:
      product.DeActiveDate ||
      product.deActiveDate ||
      '9999-12-31T23:59:59',
    UoM: product.UoM || null,
    BrandName: product.brandName ?? product.BrandName,
    ProductName: product.productName ?? product.ProductName,
    DistbInCA: product.distbInCA ?? product.DistbInCA,
    RetailPrice: formatRetailPrice(product.RetailPrice),
    FederalNutrition: product.FederalNutrition,
    ReviewerDescription: product.ReviewerDescription || null,
    Manufacturer: product.Manufacturer || null,
    ProductDesc: product.ProductDesc || null,
    ExchangeSize: product.ExchangeSize || null,
    IsBroadband: product.IsBroadband,
    ProductSpecific,
    images: (product.images || [])
      .filter(image => image.ProdImg)
      .map(image => ({
        pkProductIMG: image.pkProductIMG || 0,
        ImageName: image.ImageName,
        ImageType: image.ImageType,
        ProdImg: image.ProdImg,
      })),
  }
}

export const normalizeAtomicSubmission = (submission, padImages = false) => {
  if (!submission) return null

  const productSpecific =
    typeof submission.ProductSpecific === 'string'
      ? JSON.parse(submission.ProductSpecific)
      : submission.ProductSpecific || {}
  const normalized = { ...productSpecific, ...submission }
  delete normalized.ProductSpecific
  delete normalized.ProductSpecificJson

  const images = [...(submission.images || [])]
  if (padImages) {
    while (images.length < 4) {
      images.push({
        fkProduct: 0,
        pkProductIMG: 0,
        ImageName: '',
        ImageType: '',
        ProdImg: '',
      })
    }
  }

  return {
    ...normalized,
    category: submission.fkCategory,
    subCategory: submission.fkSubCategory,
    brandName: submission.BrandName,
    productName: submission.ProductName,
    distbInCA: submission.DistbInCA,
    images,
  }
}
